import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SWRConfig } from 'swr';
import theme from './theme/theme';
import { swrConfig } from './api/swrConfig';
import LoginPage from './pages/LoginPage.jsx';
import MyPage from './pages/MyPage.jsx';
import CompanyDashboard from './pages/CompanyDashboard.jsx';
import Complete from './pages/Complete.jsx';
import PaymentFailure from './pages/PaymentFailure.jsx';
import PaymentStatusPage from './pages/PaymentStatusPage.jsx';
import ImplPageLayout from './components/ImplPageLayout.jsx';
import ImplPage from './pages/ImplPage.jsx';
import CampaignList from './pages/CampaignList.jsx';
import Registration from './pages/CompanyRegistration.jsx';
import CampaignRegister from './pages/CampaignRegister.jsx';
import AdminPage from './pages/AdminPage.jsx';
import SignUpPage from './pages/SignUpPage.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import ForgotIDPage from './pages/ForgotIDPage.jsx';
import ForgotPasswordPage from './pages/ForgotPasswordPage.jsx';
import TermsPage from './pages/TermsPage.jsx';
import OtpVerificationPage from './pages/OtpVerificationPage.jsx';
import OtpVerificationIdPage from './pages/OtpVerificationIdPage.jsx';
import ResetPasswordByPhone from './pages/ResetPasswordPhonePage.jsx';
import ResetIdPhonePage from './pages/ResetIdPhonePage.jsx';
import ResetInformationPage from './pages/ResetInformationPage.jsx';
import PlanRegistar from './pages/PlanRegistar.jsx';
import PaymentInfoPage from './pages/PaymentInfoPage';
import CompanyCampaignsPage from './pages/CompanyCampaignsPage.jsx';
import ErrorPage from './pages/ErrorPage.jsx';
import AdminPageLayout from './components/AdminPageLayout.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SWRConfig value={swrConfig}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/payment-status" element={<PaymentStatusPage />} />
            <Route path="/complete" element={<Complete />} />
            <Route path="/payment-failure" element={<PaymentFailure />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-id" element={<ForgotIDPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/otp-verification" element={<OtpVerificationPage />} />
            <Route
              path="/otp-verification-id"
              element={<OtpVerificationIdPage />}
            />
            <Route
              path="/reset-password-phone"
              element={<ResetPasswordByPhone />}
            />
            <Route path="/reset-id-phone" element={<ResetIdPhonePage />} />
            <Route
              path="/reset-userinformation"
              element={<ResetInformationPage />}
            />

            {/* インプル側管理画面ルート */}
            <Route
              element={
                <ProtectedRoute allowedRoles="impl">
                  <ImplPageLayout />
                </ProtectedRoute>
              }
            >
              <Route path="implpage" element={<ImplPage />} />
              <Route path="registration" element={<Registration />} />
              <Route path="campaignlist" element={<CampaignList />} />
              <Route
                path="/plan-registar/:companyId"
                element={<PlanRegistar />}
              />
              <Route
                path="/campaign-register/:companyId"
                element={<CampaignRegister />}
              />
              <Route
                path="/companies/:companyId"
                element={<CompanyCampaignsPage />}
              />
            </Route>

            {/* 管理画面ルート */}
            <Route
              element={
                <ProtectedRoute allowedRoles="admin">
                  <AdminPageLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/adminpage" element={<AdminPage />} />
              <Route
                path="/dashboard/:companyId"
                element={<CompanyDashboard />}
              />
              <Route
                path="/adminpage/:companyId"
                element={<PaymentInfoPage />}
              />
            </Route>

            <Route path="/error" element={<ErrorPage />} />
            {/* どこにもマッチしない場合はトップにリダイレクト */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </SWRConfig>
    </ThemeProvider>
  );
}

export default App;
